'use client';

import { FaqCardFragment } from '@/__generated__/graphql';
import UnstyledAccordion from '@/components/UnstyledAccordion';
import { parseLinkField } from '@/lib/parsers/common';
import * as richTextStyles from '../Blocks/BlockComponents/RichTextBlock/RichTextBlock.css';
import Box from '../ui/Box';
import Btn from '../ui/Btn';
import Txt from '../ui/Txt';
import { UnstyledAccordionItemProps } from '../UnstyledAccordion/UnstyledAccordion.Item';

type FaqCardAccordionItemProps = Omit<UnstyledAccordionItemProps, 'children'> & {
  data: FaqCardFragment;
};

const FaqCardAccordionItem = ({ data, index }: FaqCardAccordionItemProps) => {
  const { id, heading, content, linkField } = data;
  const link = parseLinkField(linkField);

  return (
    <UnstyledAccordion.Item
      key={id}
      {...{
        index,
        colorSet: 'white',
        paper: true,
        LabelProps: {
          children: heading,
          variant: 'text',
          color: 'black',
        },
        BodyProps: {
          index,
          children: (
            <Box cx={{ pX: 'sm' }}>
              {content && (
                <Txt className={richTextStyles.withRichText} html>
                  {content}
                </Txt>
              )}
              {link && <Btn variant="outlined" cx={{ mT: '2xs' }} {...link} />}
            </Box>
          ),
        },
      }}
    />
  );
};

export default FaqCardAccordionItem;
